import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { ConfirmDialogConfig } from '../../dialog.types';

@Component({
  selector: 'app-confirm',
  imports: [MatButton, MatDialogModule],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss',
})
export class ConfirmComponent {
  private labels = inject(LangService).lang.shared.confirmDialog;
  private config: ConfirmDialogConfig = inject(MAT_DIALOG_DATA);
  text = this.config.text;
  title = this.config.title ?? this.labels.title;
  subtitle = this.config.subtitle ?? '';
  okText = this.config.okText ?? this.labels.okText;
  cancelText = this.config.cancelText ?? this.labels.cancelText;
}
